import type { MutationObserverResult } from '@tanstack/query-core';

export interface BillingState {
    error: string | null;
    billingHistoryLimit: number | undefined;

    setupIntentResult: MutationObserverResult<{ clientSecret: string }, Error, void, unknown> | null;
    setDefaultPaymentMethodResult: MutationObserverResult<{ success: boolean }, Error, string, unknown> | null;
}

export type BillingAction =
    | { type: 'CLEAR_ERROR' }
    | { type: 'SET_ERROR'; error: string }
    | { type: 'SET_BILLING_HISTORY_LIMIT'; limit: number | undefined }
    | {
          type: 'SETUP_INTENT_RESULT_UPDATED';
          result: BillingState['setupIntentResult'];
      }
    | {
          type: 'SET_DEFAULT_PAYMENT_METHOD_RESULT_UPDATED';
          result: BillingState['setDefaultPaymentMethodResult'];
      }
    | { type: 'RESET_SETUP_INTENT' };

export function createInitialState(): BillingState {
    return {
        error: null,
        billingHistoryLimit: undefined,
        setupIntentResult: null,
        setDefaultPaymentMethodResult: null,
    };
}

export function billingReducer(state: BillingState, action: BillingAction): BillingState {
    switch (action.type) {
        case 'CLEAR_ERROR':
            return { ...state, error: null };

        case 'SET_ERROR':
            return { ...state, error: action.error };

        case 'SET_BILLING_HISTORY_LIMIT':
            return { ...state, billingHistoryLimit: action.limit };

        case 'SETUP_INTENT_RESULT_UPDATED':
            return { ...state, setupIntentResult: action.result };

        case 'SET_DEFAULT_PAYMENT_METHOD_RESULT_UPDATED':
            return { ...state, setDefaultPaymentMethodResult: action.result };

        case 'RESET_SETUP_INTENT':
            return { ...state, setupIntentResult: null };

        default: {
            const _exhaustiveCheck: never = action;
            return state;
        }
    }
}
